import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Leaf } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.company_name}`);
      nav(u.is_admin ? "/admin" : "/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <div className="flex items-center gap-2 mb-8">
        <div className="w-10 h-10 bg-[#2C5530] rounded-xl flex items-center justify-center"><Leaf className="w-5 h-5 text-white"/></div>
        <span className="text-lg font-medium">Carbon Vaults</span>
      </div>
      <h1 className="text-4xl tracking-tighter font-light">Welcome back</h1>
      <p className="text-stone-600 mt-2">Sign in to manage your climate portfolio.</p>

      <form onSubmit={submit} className="mt-8 space-y-4">
        <div>
          <Label htmlFor="email">Work email</Label>
          <Input id="email" data-testid="login-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="mt-2 h-12 bg-stone-50 border-stone-200"/>
        </div>
        <div>
          <Label htmlFor="password">Password</Label>
          <Input id="password" data-testid="login-password" type="password" required value={password} onChange={(e)=>setPassword(e.target.value)} className="mt-2 h-12 bg-stone-50 border-stone-200"/>
        </div>
        <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full h-12 bg-[#2C5530] hover:bg-[#1F3D22] text-white rounded-full">
          {loading ? "Signing in…" : "Sign in"}
        </Button>
      </form>
      <div className="mt-6 text-sm text-stone-600">
        New here? <Link to="/register" className="text-[#2C5530] font-medium">Create account</Link>
      </div>
      <div className="mt-8 p-4 bg-stone-100 rounded-xl text-xs text-stone-600">
        <div className="font-medium mb-1">Demo admin</div>
        admin@carbonvaults.com / Admin@12345
      </div>
    </div>
  );
}
